import ko from 'knockout';
import _ from 'underscore';

const urlRegex = new RegExp('^(http|https)(://)(.+)', 'i');

export class ViewModel {
  constructor(options) {
    this.maxFullUrlLength = options.maxFullUrlLength || 2048;
    this.protocols = [{
      Value: 'https',
      Text: 'https://',
    }, {
      Value: 'http',
      Text: 'http://',
    }];

    // MT strips off the protocol from the destination URLs
    // adding a hack for now to add the protocol back to the url
    if (options.url && options.url.indexOf('http') !== 0) {
      options.url = `https://${options.url}`; // eslint-disable-line no-param-reassign
    }

    this.errorContainer = ko.observable('');
    this.errorMessage = ko.observable('');
    this.showErrors = ko.observable(false);

    this.protocol = ko.observable();
    this.urlWithoutProtocol = ko.observable();
    this.fullUrl = ko.computed({
      read: () => {
        // if no actual url is entered, then empty string should return
        if (!this.urlWithoutProtocol() || _.isEmpty(this.urlWithoutProtocol().trim())) {
          return null;
        }

        // strip off the protocol from the beginning of
        // the url (if any) and update the protocol select
        const regexResult = urlRegex.exec(this.urlWithoutProtocol().trim());
        if (regexResult) {
          this.protocol(regexResult[1]);
          this.urlWithoutProtocol(regexResult[3]);
        }

        const value = `${this.protocol()}://${this.urlWithoutProtocol().trim()}`;
        return value;
      },
      write: (value) => {
        // if the input doesn't start with the protocol, it is not valid and we show blank instead.
        const regexResult = urlRegex.exec(value);
        this.protocol(regexResult ? regexResult[1] : 'https');
        this.urlWithoutProtocol(regexResult ? regexResult[3] : '');
      },
    }, this);

    this.errorContainer(options.errorContainer);
    this.fullUrl(options.url);

    this.isDisabled = ko.observable(false);

    this.maxLength = ko.computed(() => (
      this.maxFullUrlLength - this.protocol().length - '://'.length
    ), this);

    this.hasErrors = ko.observable(false);
  }
}
